import { useState, useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { fetchTrack } from "../lib/api";
import RaceHistoryTable from "../components/RaceHistoryTable";
import SearchBar from "../components/SearchBar";
import { Horse, ArrowLeft, MapPin, Users } from "@phosphor-icons/react";

const TRACK_IMG = "https://images.pexels.com/photos/1462361/pexels-photo-1462361.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940";

export default function TrackDetail() {
  const { id } = useParams();
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTrack(id)
      .then(setData)
      .catch(console.error)
      .finally(() => setLoading(false));
  }, [id]);

  if (loading) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <p className="mono-label text-zinc-400">Loading track data...</p>
      </div>
    );
  }

  if (!data || data.error) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-center">
          <p className="text-zinc-400 text-sm mb-4">Track not found</p>
          <Link to="/tracks" className="text-sm font-mono underline">Back to Tracks</Link>
        </div>
      </div>
    );
  }

  const { track, recent_races } = data;

  return (
    <div data-testid="track-detail-page" className="min-h-screen bg-white">
      <header className="border-b border-border px-4 md:px-8 py-4 flex items-center justify-between gap-4 flex-wrap">
        <Link to="/" className="flex items-center gap-2">
          <Horse weight="fill" size={28} className="text-[#E12B00]" />
          <span className="text-lg font-heading font-black tracking-tight text-zinc-900">Racing Form Guide</span>
        </Link>
        <SearchBar />
      </header>

      <main className="p-4 md:p-8 max-w-[1400px] mx-auto">
        <Link to="/tracks" data-testid="back-to-tracks" className="inline-flex items-center gap-1 text-xs font-mono text-zinc-400 hover:text-zinc-900 transition-colors mb-6">
          <ArrowLeft weight="bold" size={14} />
          Back to Tracks
        </Link>

        <div className="relative h-[200px] md:h-[280px] border border-border overflow-hidden mb-6">
          <img src={TRACK_IMG} alt={track.name} className="w-full h-full object-cover" />
          <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
          <div className="absolute bottom-0 left-0 right-0 p-4 md:p-6">
            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-heading font-black text-white tracking-tighter">{track.name}</h1>
            <div className="flex items-center gap-4 mt-2 text-sm text-zinc-300 font-mono">
              <span className="flex items-center gap-1"><MapPin weight="bold" size={14} />{track.location}</span>
              <span>{track.surface}</span>
              <span className="flex items-center gap-1"><Users weight="bold" size={14} />{track.capacity?.toLocaleString()}</span>
            </div>
          </div>
        </div>

        <div className="border border-border p-4 bg-zinc-50 mb-6">
          <p className="text-sm text-zinc-600 leading-relaxed">{track.description}</p>
        </div>

        <div>
          <p className="mono-label text-zinc-500 mb-3">Recent Races at {track.name}</p>
          <RaceHistoryTable races={recent_races} />
        </div>
      </main>
    </div>
  );
}
